import {observable, action, runInAction} from 'mobx'

class RouterStore {
    public loadingCount: number = 0
    @observable loading: boolean = false
    @observable alarmNum: number = 0

    @action
    setLoading = (loading: boolean) => {
        if (loading) {
            this.loadingCount++
        } else {
            this.loadingCount--
        }
        if (this.loadingCount > 0) {
            runInAction(() => {
                this.loading = true
            })
        } else {
            runInAction(() => {
                this.loading = false
            })
        }
    }

    @action
    setAlarmNum = (num: number) => {
        runInAction(() => {
            this.alarmNum = num
        })
    }

}

const routerStore = new RouterStore()
export {routerStore, RouterStore}
